import request from '@/utils/request'

export function getCodeListApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: query
  })
}

export function getCurrencyListApi() {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: { pCode: 'CURR' }
  })
}
export function getLanguageListApi() {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: { pCode: 'LANG' }
  })
}
export function getReasonListApi() {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: { pCode: 'RSS' }
  })
}
export function getVIPListApi() {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: { pCode: 'VIP' }
  })
}
export function getNationListApi() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: { pCode: 'NATION' }
  })
}

export function getServiceTypeListApi() {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: { pCode: 'SERVICE_TP' }
  })
}

export function addCodeApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'post',
    data: query
  })
}
export function updateCodeApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'put',
    data: query
  })
}

export function deleteCodeApi(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'delete',
    data: query
  })
}

// ??
export function getTransPageListApi() {
  return request({
    url: '/config-service/v1/statistic/code/code-base',
    method: 'get',
    params: { pCode: 'TRANPAGE' }
  })
}

// Sytv

export function getCode(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'get',
    params: {
      pCode: query.p_code
    }
  })
}

export function addCode(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'post',
    data: query
  })
}

export function updateCode(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'put',
    data: query
  })
}

export function deleteCode(query) {
  return request({
    url: '/config-service/v1/statistic/code',
    method: 'delete',
    data: query
  })
}
